import { Fragment, isVNode } from 'vue';

import { IN_BROWSER } from '@components/utils';

export function flattenChildren(children: any[] = [], filterEmpty = true) {
  const temp = Array.isArray(children) ? children : [children];
  const res: any[] = [];

  temp.forEach((child) => {
    if (Array.isArray(child)) {
      res.push(...flattenChildren(child, filterEmpty));
    } else if (child && child.type === Fragment) {
      res.push(...flattenChildren(child.children, filterEmpty));
    } else if (child && isVNode(child)) {
      if (filterEmpty && !isEmptyElement(child)) {
        res.push(child);
      } else if (!filterEmpty) {
        res.push(child);
      }
    } else if (isValid(child)) {
      res.push(child);
    }
  });

  return res;
}

export function filterEmpty(children: any[] = []) {
  const res: any[] = [];
  children.forEach((child: any) => {
    if (Array.isArray(child)) {
      res.push(...child);
    } else if (child?.type === Fragment) {
      res.push(...filterEmpty(child.children));
    } else {
      res.push(child);
    }
  });
  return res.filter((c) => !isEmptyElement(c));
}

export function isEmptyElement(c: Record<string, any>) {
  if (!IN_BROWSER) return undefined;

  return (
    c &&
    (c.type === Comment ||
      (c.type === Fragment && c.children.length === 0) ||
      (c.type === Text && c.children.trim() === ''))
  );
}

function isValid(value: any): boolean {
  return value !== undefined && value !== null && value !== '';
}
